var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('li',{staticClass:"usa-sidenav__item",class:_vm.limatched},[_c('a',{attrs:{"aria-describedby":_vm.hrefmatched,"href":_vm.data.fields.menuItemTargetLink}},[_vm._v(_vm._s(_vm.data.fields.menuItemText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }